import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useLoading } from "../../../../util/LoadingProvider";


const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  leftGrid: {
    maxHeight: 100,
  },
  last: {
    margin: 0,
    marginTop: theme.spacing(3),
  },
  topBar: {
    padding: 0,
  },
  pagination: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  "&::placeholder": {
    color: "grey",
  },
}));

export default function OrganizationPositionPagesForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();

  const { control, handleSubmit, setValue } = useForm();
  const { setLoading } = useLoading();

  const [groupList, setGroupList] = React.useState([]);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const formatRowToData = (row) => {
    return {
      positionNameEn: row.positionNameEn,
      positionNameTc: row.positionNameTc,
      parentGroupId: row.parentGroupId,
    }
  }

  const getAllGroups = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getOrganizations({
        pageSize: 99999,
    });
      setGroupList(result.data.content);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllGroups();
    if (id) {
      apiHelper.hkiff
        .getPositionById(id)
        .then((response) => {
          console.log(response.data);
          setValue("positionNameEn", response.data.positionNameEn);
          setValue("positionNameTc", response.data.positionNameTc);
          setValue("parentGroupId", response.data.parentGroupId);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updatePosition = async (data) => {
    console.log(data);
    console.log(formatRowToData(data));
    try {
      const result = await apiHelper.hkiff.updatePositionById(
        id, formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/organization/position");
    } catch (err) {
      console.log(err);
    }
  };

  const createPosition = async (data) => {
    console.log(data);
    console.log(formatRowToData(data));
    try {
      const result = await apiHelper.hkiff.createPosition(
        formatRowToData(data)
      );
      if (result.data.code === -4) {
        toast.error("Duplicated group code.");
      } else {
        toast.dark("Position created.");

        //clear all fields
        setValue("positionNameEn", "");
        setValue("positionNameTc", "");
        setValue("parentGroupId", null);
        fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendPosition = () => {
      if (id) {
        updatePosition(data);
      } else {
        createPosition(data);
      }
    };
    sendPosition();
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="positionNameEn"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="positionNameTc"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <Controller
              name="parentGroupId"
              defaultValue=""
              control={control}
              render={({ field, fieldState: { error } }) => (
                <FormControl
                  className={classes.formControl}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                >
                  <Select
                    {...field}
                    
                    MenuProps={MenuProps}
                  >
                    {groupList &&
                      groupList.map((gp) => (
                        <MenuItem key={gp.id} value={gp.id}>
                          {gp.groupNameEn}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
            />

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
